import * as common from '../../common'

import type { ExpenseReports } from './expense-reports'

/**
 * The BCH Defend to Spend source document bundle: the cash draw workbook, the
 * three CHGLN53A reports, and the PMS subaccount summary.
 */
export type Files = common.SourceFiles<
  'cashDraw' | ExpenseReports.Role | 'subaccountSummary'
>
export namespace Files {
  export const isFiles = common.SourceFiles.checker([
    'cashDraw',
    'currentMidMonth',
    'priorMidMonth',
    'priorMonthEnd',
    'subaccountSummary',
  ])
}
